import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { BYPASS_AUTH_INTERCEPTOR } from "b2b-ecommerce-lib";
import { catchError, Observable, throwError } from "rxjs";
import { SessionService } from "../services/login.service";

export const pendingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  if (
    req.url.includes("guests") ||
    req.url.includes("token-refresh") ||
    req.url.includes("i18n") ||
    req.context.get(BYPASS_AUTH_INTERCEPTOR)
  ) {
    return next(req);
  }

  const sessionService = inject(SessionService);
  const clonedReq = req.clone({
    headers: req.headers.set("Accept-Language", localStorage.getItem("language") || "it"),
  });

  return next(clonedReq).pipe(
    catchError((err) => {
      if (err.status === 401) {
        sessionService.logout(true, true);
      }
      return throwError(() => err);
    }),
  );
};
